import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';

@Pipe({
    name: 'listTooltip',
    standalone: false
})
export class ListTooltipPipe implements PipeTransform {

    constructor(public localizationService: LocalizationService) { }

    /**
     * Creates html markup for a pTooltip with an optional label and a styled list. Note: must set [escape]=false
     * @param items string values for the list items
     * @param label optional text that preceeds the list
     * @returns tooltip inner HTML
     */
    transform(items: string[], label?: string): string {
        let tooltip;
        if (!items) {
            return tooltip;
        } else {
            tooltip = `<div class="agpr-listTooltip">${this.localizationService.transform(label)}<ul class="agpr-listTooltip-container">`;
            items.forEach(item => {
                tooltip += `<li>${this.localizationService.transform(item)}</li>`;
            });
            tooltip += '</ul></div>';
        }
        return tooltip;
    }
}
